angular.module('eStories.search.model', []).service('SearchModel', ['WS', function (WS) {
        this.autocompleteStore = (textToFind,
                                  narratorPagination,
                                  publisherPagination,
                                  authorPagination,
                                  audiobookPagination) => {
            const request = {
                textToFind: textToFind,
                narratorPagination: narratorPagination,
                publisherPagination: publisherPagination,
                authorPagination: authorPagination,
                audiobookPagination: audiobookPagination
            };
            return WS.callServer('search/autocompleteStore', request, {abortPrevious: true});
        };

        this.createArrayOfBookIds = (searchResults) => {
            return searchResults.audiobookList.map(val => {
                if (val.id) {
                    return val.id;
                }
            });
        };

        this.searchStore = (textToFind,
                            narratorPagination,
                            publisherPagination,
                            authorPagination,
                            audiobookPagination) => {
            const request = {
                textToFind: textToFind,
                narratorPagination: narratorPagination,
                publisherPagination: publisherPagination,
                authorPagination: authorPagination,
                audiobookPagination: audiobookPagination
            };
            return WS.callServer('search/searchStore', request, {abortPrevious: true});
        };

        this.searchLibrary = (textToFind,
                              narratorPagination,
                              publisherPagination,
                              authorPagination,
                              audiobookPagination) => {
            const request = {
                textToFind: textToFind,
                narratorPagination: narratorPagination,
                publisherPagination: publisherPagination,
                authorPagination: authorPagination,
                audiobookPagination: audiobookPagination
            };
            return WS.callServer('search/searchLibrary', request, {abortPrevious: true});
        };
    }]
);

